import RequestsTable from './requests-table';

export default RequestsTable;
